import StoreUpdateEvents from "../constants/events/StoreUpdateEvents";
import BaseStore from "./BaseStore";
import UIInteractionEvents from "../constants/events/UIInteractionEvents";
import LoadingStates from "../constants/states/LoadingStates";
import ActionResultEvents from "../constants/events/ActionResultEvents";

class SERPState {
    constructor(googlePlaceId, data, mapCurrentCenter, loadingState, selectedSpace, activePage) {
        this.googlePlaceId = googlePlaceId;
        this.data = data;
        this.mapCurrentCenter = mapCurrentCenter;
        this.loadingState = loadingState;
        this.selectedSpace = selectedSpace;
        this.activePage = activePage;
    }

    equals(other) {
        return this.googlePlaceId === other.googlePlaceId &&
            this.data.results === other.data.results &&
            this.data.latitude === other.data.latitude &&
            this.data.longitude === other.data.longitude &&
            this.data.count === other.data.count &&
            this.mapCurrentCenter.latitude === other.mapCurrentCenter.latitude &&
            this.mapCurrentCenter.longitude === other.mapCurrentCenter.longitude &&
            this.loadingState === other.loadingState &&
            this.selectedSpace === other.selectedSpace &&
            this.activePage === other.activePage;
    }
}

class ImmutableSERPStateBuilder {

    constructor() {
        this.googlePlaceId = "ChIJLwPMoJm1RIYRetVp1EtGm10";
        this.data = {results: [], latitude: 30.267153, longitude:-97.7430607, count: 0};
        this.mapCurrentCenter = {latitude: 30.267153, longitude: -97.7430607};
        this.loadingState = LoadingStates.INITIALIZED;
        this.selectedSpace = 0;
        this.activePage = 1;
    }

    setFromState(state) {
        return this.setGooglePlace(state.googlePlaceId)
            .setSpaces(state.data)
            .setSelectedSpace(state.selectedSpace)
            .setMapCurrentCenter(state.mapCurrentCenter.latitude, state.mapCurrentCenter.longitude)
            .setActivePage(state.activePage);
    }

    setGooglePlace(googlePlaceId) {
        this.loadingState = LoadingStates.LOADING;
        this.googlePlaceId = googlePlaceId;
        return this;
    }

    setSpaces(data) {
        this.data = data;
        this.mapCurrentCenter = {latitude: data.latitude, longitude: data.longitude};
        this.loadingState = LoadingStates.FINISHED_LOADING
        return this;
    }

    setSelectedSpace(selectedSpace) {
        this.selectedSpace = selectedSpace;
        return this;
    }

    setMapCurrentCenter(latitude, longitude) {
        this.mapCurrentCenter = {latitude: latitude, longitude: longitude};
        return this;
    }

    setActivePage(activePage) {
        this.activePage = activePage;
        this.selectedSpace = 0;
        return this;
    }

    build() {
        return Object.freeze(
            new SERPState(this.googlePlaceId, this.data, this.mapCurrentCenter, this.loadingState, this.selectedSpace, this.activePage));
    }
}


class SERPStore extends BaseStore {

    constructor() {
        super(StoreUpdateEvents.SERP_STORE_UPDATED, ImmutableSERPStateBuilder);
        this.subscribeToEvent(UIInteractionEvents.GOOGLE_PLACES_AUTO_COMPLETE_SERP_CHANGE, this.handleSearchChange);
        this.subscribeToEvent(ActionResultEvents.FIND_SPACE_LOADED, this.handleSpaceLoaded);
        this.subscribeToEvent(UIInteractionEvents.SPACE_MARKER_CLICK, this.handleSpaceMakerClick);
        this.subscribeToEvent(UIInteractionEvents.MAP_CENTER_CHANGED, this.handleMapCenterChange);
        this.subscribeToEvent(UIInteractionEvents.PAGINATION_CHANGE, this.handlePaginationChange);

    }

    handleSearchChange = (topic, data) => {
        return new ImmutableSERPStateBuilder()
            .setFromState(this.state)
            .setGooglePlace(data.placeId)
            .build();
    };

    handleSpaceLoaded = (topic, data) => {
        return new ImmutableSERPStateBuilder()
            .setFromState(this.state)
            .setSpaces(data)
            .build();
    };

    handleSpaceMakerClick = (topic, data) => {
        return new ImmutableSERPStateBuilder()
            .setFromState(this.state)
            .setSelectedSpace(data.spaceId)
            .build()
    };

    handleMapCenterChange = (topic, data) => {
        return new ImmutableSERPStateBuilder()
            .setFromState(this.state)
            .setMapCurrentCenter(data.latitude, data.longitude)
            .build();
    };

    handlePaginationChange = (topic, data) => {
        return new ImmutableSERPStateBuilder()
            .setFromState(this.state)
            .setActivePage(data)
            .build();
    };

}

export default new SERPStore();